import { Link } from "react-router-dom";

const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_github-converter-1/artifacts/4x1ai3x8_techport_logo_white_transparent.png";

export const Brand = ({ to = "/", variant = "light" }) => {
  const isDark = variant === "dark";
  const logoColor = isDark ? "#FFFFFF" : "#1B1B3A";
  const subColor = isDark ? "rgba(255,255,255,0.5)" : "#6B6B85";
  return (
    <Link to={to} className="flex items-center gap-3 group" data-testid="brand-logo">
      {/* Techport logo — color-tinted via CSS mask so it adapts to dark/light backgrounds */}
      <span
        aria-label="Techport"
        className="block"
        style={{
          width: "120px",
          height: "44px",
          backgroundColor: logoColor,
          WebkitMaskImage: `url(${LOGO_URL})`,
          maskImage: `url(${LOGO_URL})`,
          WebkitMaskRepeat: "no-repeat",
          maskRepeat: "no-repeat",
          WebkitMaskPosition: "left center",
          maskPosition: "left center",
          WebkitMaskSize: "contain",
          maskSize: "contain",
          flexShrink: 0,
        }}
      />
      <div className="leading-none border-l-2 pl-3" style={{ borderColor: isDark ? "rgba(255,255,255,0.2)" : "rgba(27,27,58,0.15)" }}>
        <span
          className="block font-display text-xl tracking-tight"
          style={{ color: "#3FCBA6", lineHeight: 1, letterSpacing: 0 }}
        >
          AI CHECK
        </span>
        <span
          className="block font-condensed uppercase mt-1"
          style={{ color: subColor, fontSize: "10px", letterSpacing: "0.2em", fontWeight: 600 }}
        >
          Persoonlijk AI-actieplan
        </span>
      </div>
    </Link>
  );
};
